export default __webpack_public_path__ + "static/media/KOD0101-min.6d12c1ae.webp";